import { Buffer } from 'buffer/';

class Crypter {
    encode = (value) => {
        if(typeof value == 'object') {
            value = JSON.stringify(value);
        }
        return Buffer.from(value).toString('base64');
    }
    decode = (value) => {
        let unEnCode = Buffer.from(value, 'base64').toString();
        try {
            unEnCode = JSON.parse(unEnCode);
        }
        catch {
        }
        return unEnCode;
    }
}

export default new Crypter();